import { Evaluation } from '@program/shared/evaluation/evaluation.model';

export function scoreBuilder(data: Evaluation, pass: object, fail: object) {
  if (data?.evaluationConfig?.type === 'SCORE' &&
    data?.scoreValue !== null &&
    data.evaluationConfig?.rangeEnd !== null) {
    return data?.scoreValue + '/' + data?.evaluationConfig.rangeEnd;
  }

  if (data?.evaluationConfig?.type === 'PASS_FAIL' &&
    data?.boolValue !== null) {
    const bool = data?.boolValue;
    if (bool) {
      return pass;
    }
    return fail;
  }

  return '--';
}
